var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaundry = function SvgLaundry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M15.417 20c0-.69.56-1.25 1.25-1.25h.016a1.25 1.25 0 0 1 0 2.5h-.016c-.69 0-1.25-.56-1.25-1.25M23.333 18.75a1.25 1.25 0 0 0 0 2.5h.017a1.25 1.25 0 0 0 0-2.5z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M20 8.75a11.25 11.25 0 1 0 0 22.5 11.25 11.25 0 0 0 0-22.5m-6.187 5.063a8.75 8.75 0 1 1 12.374 12.375 8.75 8.75 0 0 1-12.374-12.375",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M10 3.75A6.25 6.25 0 0 0 3.75 10v20A6.25 6.25 0 0 0 10 36.25h20A6.25 6.25 0 0 0 36.25 30V10A6.25 6.25 0 0 0 30 3.75zM7.348 7.348A3.75 3.75 0 0 1 10 6.25h20A3.75 3.75 0 0 1 33.75 10v20A3.75 3.75 0 0 1 30 33.75H10A3.75 3.75 0 0 1 6.25 30V10a3.75 3.75 0 0 1 1.098-2.652",
    clipRule: "evenodd"
  })));
};
export default SvgLaundry;